/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define([
    'require',
    'jquery',
    'knockout',
    '../../appContext',
    'raw-loader!./dvuserentry.html',
    './dvuserentry.css',
],
function (require, $, ko, app, componentTemplate) {
    "use strict";

    var dvTouchBox = {};

    dvTouchBox.componentName = "";

    function componentViewModel(params) {
        var vm = {};

        //Get model object
        vm.classObject = params.objModel;

        //Wire up properties to model object
        vm.cancelPress = vm.classObject().cancelPress;
        vm.titleText = vm.classObject().titleText;
        vm.submitPress = vm.classObject().submitPress;
        vm.indent = vm.classObject().indent;
        vm.outdent = vm.classObject().outdent;
        vm.bold = vm.classObject().bold;
        vm.italic = vm.classObject().italic;
        vm.underline = vm.classObject().underline;
        vm.unorderedList = vm.classObject().unorderedList;
        vm.orderedList = vm.classObject().orderedList;
        vm.fontSize = vm.classObject().fontSize;

        vm.showEditorBar = vm.classObject().showEditorBar;
        vm.showInputArea = vm.classObject().showInputArea;
        vm.showInputNumber = vm.classObject().showInputNumber;
        vm.showInputDate = vm.classObject().showInputDate;
        vm.showInputText = vm.classObject().showInputText;
        vm.showInputSelect = vm.classObject().showInputSelect;
        vm.showRTFDiv = vm.classObject().showRTFDiv;

        vm.textAreaInput = vm.classObject().textAreaInput;
        vm.RTFInput = vm.classObject().RTFInput;
        vm.numberInput = vm.classObject().numberInput;
        vm.dateInput = vm.classObject().dateInput;
        vm.textInput = vm.classObject().textInput;
        vm.list = vm.classObject().list;
        vm.index = vm.classObject().index;
        vm.comboInput = vm.classObject().comboInput;
        vm.comboSelection = vm.classObject().comboSelection;

        return vm;
    }

    dvTouchBox.component = {};
    dvTouchBox.component.viewModel = componentViewModel;
    dvTouchBox.component.template = componentTemplate.default;

    dvTouchBox.model = function () {
        var m = {};

        m.componentName = ko.observable(dvTouchBox.componentName);
        m.boundNameProperty = ko.observable(m.componentName());
        m.boundShowProperty = ko.observable(false);
        m.htmlId = "touchBox";

        m.titleText = ko.observable("Title Text");
        m.textAreaInput = ko.observable();
        m.RTFInput = ko.observable();
        m.numberInput = ko.observable();
        m.dateInput = ko.observable();
        m.textInput = ko.observable();
        m.list = ko.observableArray();
        m.index = ko.observable();
        m.comboInput = ko.observable();
        m.comboSelection = ko.observable();

        m.showEditorBar = ko.observable(false);
        m.showInputArea = ko.observable(false);
        m.showInputNumber = ko.observable(false);
        m.showInputDate = ko.observable(false);
        m.showInputText = ko.observable(false);
        m.showRTFDiv = ko.observable(false);
        m.showInputSelect = ko.observable(false);
        m.showTimeout = 0;

        m.src = null;
        var listening = false;

        m.htmlWindowResize = function (x, y) {
            if (m.canvas != null && m.src != null) {
                //TODO: get margins of workspace dynamically...TB
                var workarea = document.getElementById("touchBox"),
                    h = window.innerHeight, w = window.innerWidth;


                // workarea.style.left = "";
                //TODO: left is being overwritten to 0...TB
                workarea.style.opacity = 1;
                workarea.style.left = x + "px";
                workarea.style.top = y + "px";
            }
        };

        m.show = function () {
            if (m.src == null) {
                throw new Error("Cannot show input without initializing");
            }
            m.boundShowProperty(true);

            if (listening == false) {
                if (window.addEventListener) {
                    window.addEventListener("resize", m.htmlWindowResize);
                }
                else {
                    window.attachEvent("resize", m.htmlWindowResize);
                }
                listening = true;
            }
            m.showTimeout = setTimeout(function (model) {
                m.showTimeout = 0;

                if (model.list() != null && model.list().length > 0) {
                    $("#inputCombo").focus();
                    var select = document.getElementById("inputCombo");
                    select.selectedIndex = model.index();
                }
                else {
                    switch (model.src.dynamicValue.DataType) {
                        case app.dv.types.PropertyDataType.DateTime:
                        case app.dv.types.PropertyDataType.StaticDateTime:
                            $("#inputDate").focus();
                            break;

                        case app.dv.types.PropertyDataType.Decimal:
                        case app.dv.types.PropertyDataType.Integer:
                            $("#inputNumber").focus();
                            selectAll();
                            break;

                        case app.dv.types.PropertyDataType.RTF:
                        case app.dv.types.PropertyDataType.InlineRTF:
                            $("#RTFfield").focus();
                            selectAll();
                            break;

                        case app.dv.types.PropertyDataType.Text:
                            $("#areaText").focus();
                            selectAll();
                            break;

                        case app.dv.types.PropertyDataType.Bit:
                        case app.dv.types.PropertyDataType.Binary:
                        default:
                            console.log("Invalid Attempt To Enter Binary / Bit Data By Touch Keybaord");
                            break;
                    }
                }
            }, 50, m);

        };

        function selectAll() {
            document.execCommand("selectall", null, false);
        }


        m.hide = function () {
            m.boundShowProperty(false);
        };

        m.cancelPress = function () {
            m.hide();
            m.callback();
            reset();
        };

        function reset() {
            m.comboInput(null);
            m.comboSelection(null);
            m.list(null);
            m.showInputSelect(false);
            m.dateInput(null);
            m.showInputDate(false);
            m.numberInput(null);
            m.showInputNumber(false);
            m.textAreaInput(null);
            m.showInputArea(false);
            m.textInput(null);
            m.showInputText(false);
            m.showRTFDiv(false);
            m.RTFInput(null);
            m.showEditorBar(false);
        }

        function removeSeparator(string) {
            var userLanguage = window.navigator.userLanguage || window.navigator.language,
                separator = Number(1009).toLocaleString(userLanguage).substring(1, 2);

            if (separator === ",") {
                return string.replace(/,/g, '');
            }
            else if (separator === ".") {
                return string.replace(/./g, '');
            }
            else {
                return string;
            }

        }

        m.init = function (dvGridValue, titleText, defaultValue, callback, list, index) {
            if (dvGridValue != null) {
                m.src = dvGridValue;
            }
            else {
                m.src = {};
                m.src.dynamicValue = {};
                m.src.dynamicValue.DataType = app.dv.types.PropertyDataType.Text;
                m.src.displayProperties = {
                    Text: null,
                    setText: function (newValue) {
                        m.src.displayProperties.Text = newValue;
                    },
                    getText: function () {
                        return m.src.displayProperties.Text;
                    }
                };
            }
            if (titleText != null) { m.titleText(titleText); }
            m.callback = callback;

            //This is a combo Box
            if (list != null) {
                m.list(list);
                m.index(index);
                m.comboSelection(list[index]);
                m.showInputSelect(true);
            }
            else {
                switch (m.src.dynamicValue.DataType) {
                    case app.dv.types.PropertyDataType.DateTime:
                    case app.dv.types.PropertyDataType.StaticDateTime:
                        if (defaultValue != null && defaultValue != "") {
                            var date = new Date(defaultValue);
                            m.dateInput(date.getFullYear() + "-" + padLeft(date.getMonth() + 1, "0", 2) + "-" + padLeft(date.getDate(), "0", 2));
                        }
                        else {
                            m.dateInput(m.src.displayProperties.Text);
                        }
                        m.showInputDate(true);
                        break;

                    case app.dv.types.PropertyDataType.Decimal:
                    case app.dv.types.PropertyDataType.Integer:
                        if (defaultValue != null) {
                            defaultValue = removeSeparator(defaultValue);
                            m.numberInput(defaultValue);
                        }
                        else {
                            m.numberInput(m.src.displayProperties.Text);
                        }
                        m.showInputNumber(true);
                        break;
                    //case app.dv.types.PropertyDataType.Text:
                    case app.dv.types.PropertyDataType.RTF:
                    case app.dv.types.PropertyDataType.InlineRTF:
                        m.RTFInput(defaultValue);
                        m.showRTFDiv(true)
                        m.showEditorBar(true);
                        break;
                    case app.dv.types.PropertyDataType.Text:
                        if (defaultValue != null) {
                            m.textAreaInput(defaultValue);

                        }
                        else {
                            m.textAreaInput(m.src.displayProperties.Text);
                        }
                        m.showInputArea(true);
                        break;

                    case app.dv.types.PropertyDataType.Bit:
                    case app.dv.types.PropertyDataType.Binary:
                    default:
                        console.log("Invalid Attempt To Enter Binary / Bit Data By Touch Keybaord");
                        break;
                }
            }
        };

        m.dispose = function () {
            if (m.showTimeout != 0) {
                clearTimeout(m.showTimeout);
            }
            if (listening == true) {
                if (window.removeEventListener) {
                    window.removeEventListener("resize", m.htmlWindowResize);
                }
                else {
                    window.detachEvent("resize", m.htmlWindowResize);
                }
                listening = false;
            }
            m.src = null;
            m.hide();
        };

        m.submitPress = function () {

            if (m.comboSelection() != null) {
                //This is a combo box
                m.src.displayProperties.setText(m.comboSelection());
            }
            else {
                switch (m.src.dynamicValue.DataType) {
                    case app.dv.types.PropertyDataType.DateTime:
                    case app.dv.types.PropertyDataType.StaticDateTime:
                        var newValue, tempDate = m.dateInput(), year, month, day;
                        if (tempDate.length == 10 && tempDate.charAt(4) == "-" && tempDate.charAt(7) == "-") {
                            year = tempDate.substring(0, 4);
                            month = tempDate.substring(5, 7);
                                //The month has to be subtracted because it uses the 0 index model...BC
                            month--;
                            day = tempDate.substring(8, 10);
                            m.src.displayProperties.setText((new Date(year, month, day).addHours((new Date().getTimezoneOffset() / 60))).toDateString());
                        }
                        else {
                            if (tempDate != null && tempDate != "") {
                                tempDate = new Date(tempDate);
                                tempDate.setHours(0, 0, 0);
                            }
                            m.src.displayProperties.setText(tempDate);
                        }

                        break;

                    case app.dv.types.PropertyDataType.Decimal:
                    case app.dv.types.PropertyDataType.Integer:
                        m.src.displayProperties.setText(m.numberInput());
                        break;

                    case app.dv.types.PropertyDataType.RTF:
                    case app.dv.types.PropertyDataType.InlineRTF:
                        var data = document.getElementById("RTFfield").innerHTML;
                        m.src.displayProperties.setText(data);
                        break;

                    case app.dv.types.PropertyDataType.Text:
                        if (m.showInputArea() == true) {
                            m.src.displayProperties.setText(m.textAreaInput());
                        }
                        else {
                            m.src.displayProperties.setText(m.textInput());
                        }
                        break;

                    case app.dv.types.PropertyDataType.Bit:
                    case app.dv.types.PropertyDataType.Binary:
                    default:
                        console.log("Invalid Attempt To Enter Binary / Bit Data By Touch Keybaord");
                        break;
                }

            }
            m.hide();
            m.callback(m.src.displayProperties.getText());
            reset();
        };

        //when using the document.execCommand, it has to be called on a text selection.
        //without that, it doesn't do anything.  This function will create and delete a character
        //to allow the type selected (bold, italic, etc) to apply to the following text.
        function fakeInput(type, size) {
            var selObj = document.getSelection();
            //get range of selected position
            var selRange = selObj.getRangeAt(0);
            //Insert node with dummy text 'd'
            var newNode = document.createTextNode('d');
            selRange.insertNode(newNode);
            selObj.removeAllRanges();
            selObj.addRange(selRange);

            //Execute command on dummy
            if (type == "fontSize") {
                document.execCommand(type, false, size);
            }
            else {
                document.execCommand(type, false, null);
            }
            //Delete dummy from range
            selRange.setStart(newNode, 0);
            selRange.setEnd(newNode, 1);
            selRange.deleteContents();

            selObj.removeAllRanges();
            selObj.addRange(selRange);
        }

        function restoreFocus() {
            var ae = document.getElementById("RTFfield");
            setTimeout(function () {
                ae.focus()
            }, 1);
        }

        //Necessary for indent and outdent.  If you click off the editable div (any gray area in the box) and press the indent or outdent button,
        //the action will apply to the actual editor bar and move it left and right as well as shift it up.  It will then cause its div box to cover
        //up the cancel and submit buttons, preventing the user from closing the editable div.  Having an instant focus restore fixes this...BC
        function restoreFocusInstant() {
            var ae = document.getElementById("RTFfield");
            ae.focus();
        }

        function padLeft(padString, padChar, length) {
            if (padChar == undefined || padChar == null) {
                padChar = " ";
            }

            if (padString == null) {
                return null;
            }

            if (typeof padString != 'string') {
                padString = padString.toString();
            }

            while (padString.length < length) {
                padString = padChar + padString;
            }

            return padString;
        }

        m.bold = function () {
            restoreFocus();
            if (document.getSelection() != "") {
                document.execCommand('bold', false, null);
            }
            else {
                fakeInput('bold');
            }
        }

        m.italic = function () {
            restoreFocus();
            if (document.getSelection() != "") {
                document.execCommand('italic', false, null);
            }
            else {
                fakeInput("italic");
            }
        }

        m.underline = function () {
            restoreFocus();
            if (document.getSelection() != "") {
                document.execCommand('underline', false, null);
            }
            else {
                fakeInput("underline");
            }
        }

        m.orderedList = function () {
            restoreFocus();
            if (document.getSelection() != "") {
                document.execCommand('insertOrderedList', false, null);
            }
            else {
                fakeInput("insertOrderedList");
            }
        }

        m.unorderedList = function () {
            restoreFocus();
            if (document.getSelection() != "") {
                document.execCommand('insertUnorderedList', false, null);
            }
            else {
                fakeInput("insertUnorderedList");
            }
        }

        m.fontSize = function (sizeDDL) {
            restoreFocus();
            if (sizeDDL != null && sizeDDL.event != null && sizeDDL.event.currentTarget != null) {
                if (document.getSelection() != "") {
                    document.execCommand('fontSize', false, sizeDDL.event.currentTarget.value);
                }
                else {
                    fakeInput("fontSize", sizeDDL.event.currentTarget.value);
                }
            }
        }

        m.indent = function () {
            restoreFocusInstant();
            if (document.getSelection() != "") {
                document.execCommand('indent', false, null);
            }
            else {
                fakeInput('indent');
            }
        }

        m.outdent = function () {
            restoreFocusInstant();
            if (document.getSelection() != "") {
                document.execCommand('outdent', false, null);
            }
            else {
                fakeInput('outdent');
            }
        }

        return m;

    };

    dvTouchBox.register = function () {
        dvTouchBox.componentName = app.dv.appSpace.id + "-dvTouchBox";
        if (!ko.components.isRegistered(dvTouchBox.componentName))
            ko.components.register(dvTouchBox.componentName, dvTouchBox.component)
    };

    return dvTouchBox;
});
